import styled from "styled-components";
import { css } from "styled-components";
import { IE11Only } from "../../_utils/styleUtils";

const paddingTop = css`
  padding-top: 1.5em;
`;

export const Wrapper = styled.div`
  display: inherit;
  flex: 0 0 5.4em;
  position: relative;
  align-items: center;
  justify-content: center;

  /* Fix misalignment in IE11 */
  ${IE11Only(paddingTop)};
`;
